export default {
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    mandatorySignIn: false,
    oauth: {
      domain: process.env.VUE_APP_COGNITO_DOMAIN,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${process.env.VUE_APP_BASE_URL || 'http://localhost:8081/'}signin`,
      redirectSignOut: process.env.VUE_APP_BASE_URL || 'http://localhost:8081/',
      responseType: 'code',
      label: 'Sign in with Betmakers SSO'
    }
  }
}
